// extracted by mini-css-extract-plugin
export default {"tooltip":"YB-z","arrow":"ZB-z"};